export default function getUtcTime(offset = 0): Date {
  const now = new Date();
  const utc = now.getTime() + now.getTimezoneOffset() * 60000;
  const nd = new Date(utc + 3600000 * offset);
  return nd;
}
